import React, { useState } from 'react';
import ArrangementOrganizationSelector from '../shared/arrangement_organization_selector';

const getDefaultOrganizationIds = (): number[] => {
  const organizationIds = utils.getParam('organization_ids');
  if (!organizationIds) {
    return [];
  }
  return organizationIds.split(',').map((id: string) => parseInt(id, 10));
};

type UseOrganizationSelectorReturn = [number[], () => JSX.Element, ((ids: number[]) => void)?];

const useOrganizationSelector = (): UseOrganizationSelectorReturn => {
  const [organizationIds, setOrganizationIds] = useState<number[]>(getDefaultOrganizationIds());

  const renderOrganizationSelector = () => (
    <ArrangementOrganizationSelector
      selectedOrganizationIds={organizationIds}
      onSelect={ids => setOrganizationIds(ids)}
    />
  );

  return [organizationIds, renderOrganizationSelector, setOrganizationIds];
};

export default useOrganizationSelector;
